import Firebase from "firebase";
import VueCookies from "vue-cookies";

const state = {
  valor_receitas: 0,
  valor_despesas: 0,
  principais_receitas: [],
  principais_despesas: [],
  isSuccess: false
};

const mutations = {
  setValorReceitas: (state, payload) => {
    state.valor_receitas = payload;
  },
  setValorDespesas: (state, payload) => {
    state.valor_despesas = payload;
  },
  setPrincipaisReceitas: (state, payload) => {
      state.principais_receitas = payload;
  },
  setPrincipaisDespesas: (state, payload) => {
    state.principais_despesas = payload;
  },
  setIsSuccess: (state, payload) => {
    state.isSuccess = payload;
  }
};

const actions = {
  getTransacoesDoMesInFirestore: async ({ commit }) => {
    let receitas = [];
    let despesas = [];
    let _associacao = VueCookies.get("IDASSOCIACAO");
    let date = new Date();
    let mesConsultar = new Date(date.getFullYear(), date.getMonth(), 1);
    // console.log(mesConsultar)

    await Firebase.firestore()
      .collection("transacoes")
      .where("_associacao", "==", _associacao)
      .where("data", ">", mesConsultar)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(function(doc) {
          if (doc.data().valor > 0)
            receitas.push(doc.data());
          else
            despesas.push(doc.data())
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });

      let valor_receitas = receitas.reduce((sum, receita) => {
          return parseFloat(sum) + receita.valor;
      }, [0]);

      let valor_despesas = despesas.reduce((sum, despesa) => {
        return parseFloat(sum) + despesa.valor;
      }, [0]);

      commit("setValorReceitas", valor_receitas);
      commit("setValorDespesas", valor_despesas);


    //   console.log(receitas, valor_receitas, valor_despesas);
  }
};

const getters = {
  getValorReceitas: state => state.valor_receitas,
  getValorDespesas: state => state.valor_despesas,
  getPrincipaisReceitas: state => state.principais_receitas,
  getPrincipaisDespesas: state => state.principais_despesas,
  getIsSuccess: state => state.isSuccess
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
